import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Button from '@ui-lib/components/Button';

import Stepper, { StepperStep } from '@ui-lib/components/Stepper';
import Card from '@ui-lib/components/Card';

import { Header } from '../../../components/Header';
import { Step1 } from './Step1';
import { Step2 } from './Step2';
import { Step3 } from './Step3';
import { SubmitButton } from './SubmitButton';

interface Props {
  activeStep: number;
  steps: StepperStep[];
  goBack: () => void;
}

const sx = {
  root: {
    display: 'grid',
    gridTemplateRows: 'auto auto 1fr auto',
    backgroundColor: 'background.default',
    height: '100%',
    width: '100%',
  },
  container: {
    margin: '0 auto',
    maxWidth: '1024px',
    width: '100%',
    boxSizing: 'border-box',
  },
  content: {
    p: 2,
    margin: '0 auto',
    maxWidth: '1024px',
    width: '100%',
    overflowY: 'auto',
    boxSizing: 'border-box',
  }
};

export const StepLayout = ({ activeStep, steps, goBack }: Props) => {
  const { t } = useTranslation();

  const renderStepContent = (step: number) => {
    switch (step) {
      case 0:
        return <Step1 />;
      case 1:
        return <Step2 />;
      case 2:
        return <Step3 />;
      default:
        return null;
    }
  };

  return (
    <Stack sx={sx.root}>
      <Header />
      <Box sx={sx.container} p={2} >
        <Typography variant="h6" gutterBottom>
          {t('bolCreatePage_title')}
        </Typography>
        <Stepper steps={steps} activeStep={activeStep} />
      </Box>
      <Box sx={sx.content} >
        {renderStepContent(activeStep)}
      </Box>

      <Card testID="step-layout-footer">
        <Stack direction="row" spacing={2} sx={sx.container} >
          {activeStep > 0 && (
            <Button
              variant="outlined"
              onClick={goBack}
              startIcon={<ChevronLeftIcon />}
              sx={{ flex: 1 }}
              size="large"
            >
              Back
            </Button>
          )}
          <SubmitButton activeStep={activeStep} />
        </Stack>
      </Card>
    </Stack>
  );
};
